import type {Balance} from '../../model';
import {Button, Money} from '../atoms';
import {useState} from "react";
import {SettlementDialog} from "./SettlementDialog";
import {useProfile} from "../../hooks";
import {useTerminalStore} from "../../store";
import {TwoFactorAuthDialog} from "./TwoFactorAuthDialog";
import { ManualSettlementDialog } from './ManualSettlementDialog';

type BalanceWidgetCardProps = {
    item: Balance | undefined
    title: 'balance' | 'deposit' | 'withdrawal'
}

export const BalanceWidgetCard = ({item, title}: BalanceWidgetCardProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isManualOpen, setIsManualOpen] = useState(false);
    const [is2FADialogOpen, setIs2FADialogOpen] = useState(false);
    const profile = useProfile();
    const { terminalId } = useTerminalStore();
    const isSettlementVisible = !!profile?.permissions.includes('settlement.create')
    const isManualSettlementVisible = !!profile?.permissions.includes('settlement.manual.create')
    const isDepositTerminal = item?.flowType === 'DEPOSIT'

    const onClose = () => {
        setIsOpen(false);
    }

    const handleSettlementClick = () => {
        if (!profile?.is2faEnabled) {
            setIs2FADialogOpen(true);
            return;
        }
        setIsOpen(true);
    }

    const handleManualSettlementClick = () => {
        setIsManualOpen(true);
    }

    return (
        <>
            <li className="flex-1 p-4 rounded-2xl shadow-1 bg-white flex flex-col text-center grid grid-rows-[auto_auto] relative">
                <span className="block text-brand-2 first-letter:uppercase">{title}</span>
                {title === 'balance' && isDepositTerminal && (isSettlementVisible || isManualSettlementVisible) && (
                  <div className="absolute z-10 top-4 right-4 flex gap-2">
                    {isManualSettlementVisible && (
                      <Button
                        className="rounded-full outline-0 cursor-pointer !w-10 !h-10 !p-0 flex-center"
                        onClick={handleManualSettlementClick}
                        title="Manual settlement"
                      >
                        M
                      </Button>
                    )}
                    {isSettlementVisible && (
                      <Button
                        className="rounded-full outline-0 cursor-pointer !w-10 !h-10 !p-0 flex-center"
                        onClick={handleSettlementClick}
                      >
                        &uarr;&darr;
                      </Button>
                    )}
                  </div>
                )}
                <span className="relative h-[30px] flex-center">
                  {!!item?.balance
                      ? <strong>
                          <Money amount={item?.balance[0].sum} currency={item?.balance[0].currency}/>
                      </strong>
                      : (
                          <div className="animate-pulse">
                              <div className="h-[20px] rounded bg-brand-2 w-fit text-brand-2">{title}</div>
                          </div>
                      )
                  }
                </span>
            </li>
            {isSettlementVisible && !!terminalId && <SettlementDialog isOpen={isOpen} onClose={onClose}/>}
            {isManualSettlementVisible && !!terminalId && (
              <ManualSettlementDialog isOpen={isManualOpen} onClose={() => setIsManualOpen(false)} />
            )}
            <TwoFactorAuthDialog isOpen={is2FADialogOpen} onClose={() => setIs2FADialogOpen(false)} />
        </>
    );
};
